import { addMinutes } from "date-fns";

export function toUtc(date: Date): Date {
    return addMinutes(date, date.getTimezoneOffset());
}
